import React, { useCallback, useEffect, useState } from 'react';
import c from 'classnames';

import { ClickAwayListener, Popper } from '@lyearn/ui';

import { LinkBar } from '../../components/LinkBar';
import {
  useAnchorEl,
  useOffset,
  useOnHrefChange,
  usePopperOptions,
} from '../SelectionMenu/useActionSelectionMenu';
import { linkMarkMenuPopper } from './styles';
import { linkMarkMenuProps } from './types';
import { useOnLinkDelete, useOnLinkSave } from './useActionLinkMarkMenu';
import { hideLinkMarkMenu } from './utils';

export const LinkMarkMenu: React.FC<linkMarkMenuProps> = (props) => {
  let { open, editorView: view, link } = props;
  let [href, setHref] = useState(link || '');

  useEffect(() => {
    if (!open) {
      setHref('');
    }
    if (link) {
      setHref(link);
    }
  }, [link, open]);

  const anchorEl = useAnchorEl(open, view);
  const offset = useOffset(open, view);
  const popperOptions = usePopperOptions(offset);

  const onLinkSave = useOnLinkSave(view, href);
  const onLinkDelete = useOnLinkDelete(view);
  const onHrefChange = useOnHrefChange(view, setHref);

  const onClickAway = useCallback(() => {
    hideLinkMarkMenu(view?.state, view?.dispatch);
  }, [view.dispatch, view.state]);

  return (
    <ClickAwayListener mouseEvent="onMouseUp" onClickAway={onClickAway}>
      <Popper
        anchorEl={anchorEl}
        className={c('rounded-8 border border-border bg-bg-primary shadow-02', linkMarkMenuPopper)}
        open={open}
        placement={document.dir === 'ltr' ? 'top-start' : 'top-end'}
        popperOptions={popperOptions}
        onClick={(event) => event.stopPropagation()}>
        <LinkBar
          editMode={!!link}
          href={href}
          setHref={onHrefChange}
          onDelete={onLinkDelete}
          onSave={onLinkSave}
        />
      </Popper>
    </ClickAwayListener>
  );
};
